import * as React from "react";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { CancelRegularCrystallisationAction } from "../CancelRegularCrystallisationWizard/Actions/CancelRegularCrystallisationAction";
import { EditIncomeDrawdownAction } from "./Actions/EditIncomeDrawdownAction";
import { IncomePaymentDetails } from "./Components/IncomePaymentDetails/IncomePaymentDetails";
import { DrawdownDetails } from "./Components/DrawdownDetails/DrawdownDetails";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { Review } from "./Components/Review/Review";
import { EditIncomeDrawdownSteppersMap, productMap } from "./Resource/Contents";
import { EditIncomeDrawdownInstructionStore } from "./Stores/Variable";
import { IStepConfig, StepType } from "../../../../Shared/Process/Process/Process";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { Action } from "../../../Actions/Action";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { GetRegularCrystallisationAction } from "../CancelRegularCrystallisationWizard/Actions/GetRegularCrystallisationAction";
import { addWeeks } from "../../../../../react-core/utils/date";
interface IEditIncomeDrawdownWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
}
export class EditIncomeDrawdownWizard extends AccountContextWizardComponent<IEditIncomeDrawdownWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(EditIncomeDrawdownInstructionStore, () => this.onInstructionStoreChange());
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null,
        };
        GetRegularCrystallisationAction.getRegularCrystallisation(getQueryParameters()["hierarchyid"], (result) => {
            this.setState({
                extraInfo: {
                    ...this.state.extraInfo,
                    defaultRegularDrawdown: result,
                    defaultRegularDrawdownSet: false
                },
            });
        });
    }

    private onInstructionStoreChange() {
        let data = EditIncomeDrawdownInstructionStore.getData();
        const type = Number(getQueryParameters()["type"]);
        if ((data.Contribution.Type === null || data.Contribution.Type === 0) && !(isNaN(type))) {
            data.Contribution.Type = Number(getQueryParameters()["type"]);
        }
        this.setState({
            isLoading: false,
            data: data,
        });
    }

    private onPostDrawdown() {
        if (EditIncomeDrawdownInstructionStore.getActionType() == ActionType.Loading) {
            this.setState({ onPosting: true });
        }
    }

    private setDefaultRegularDrawdownValues() {
        const { data, extraInfo } = this.state;
        const { Contribution } = data;
        const { DrawdownModel } = Contribution;
        const { RegularCrystallisationDetails } = DrawdownModel;

        const minimumDate = JsonDateParser.toJsonDateNoOffset(addWeeks(new Date(), 2));

        const updatedDetails = {
            ...RegularCrystallisationDetails,
            Amount: RegularCrystallisationDetails.IncomeRequired || extraInfo.defaultRegularDrawdown?.ProposedCrystallisation,
            Frequency: RegularCrystallisationDetails.Frequency || extraInfo.defaultRegularDrawdown?.Frequency,
            FirstPaymentDay: RegularCrystallisationDetails.FirstPaymentDay || minimumDate
        };

        this.setState({
            extraInfo: {
                ...extraInfo,
                defaultRegularDrawdownSet: true
            },
            data: {
                ...data,
                Contribution: {
                    ...Contribution,
                    DrawdownModel: {
                        ...DrawdownModel,
                        RegularCrystallisationDetails: updatedDetails
                    }
                }
            }
        });
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        this.getProductDetails(hierarchyId);
    }

    componentDidUpdate(prevProps) {
        if (this.state.data?.Contribution?.DrawdownModel != null && !this.state.extraInfo.defaultRegularDrawdownSet) {
            this.setDefaultRegularDrawdownValues();
        }
        const { customer, clientAccount } = this.state;
        if (clientAccount && customer && !this.state.data) {
            const id = getQueryParameters()["id"];
            const type = Number(getQueryParameters()["type"]);

            const npr = clientAccount.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr);
            if (npr) {
                EditIncomeDrawdownAction.getInstruction(
                    id,
                    type,
                    clientAccount.HierarchyId,
                    npr.HierarchyId,
                    customer.CustomerId,
                );
            }
        }
    }

    private getProductDetails(hierarchyId: string) {
        const _date = JsonDateParser.getFormatDateString(new Date(), "yyyy/MM/dd") as any;
        Action.getProductsValuationDetailSummary(hierarchyId, null, _date);
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const steppers: IStepConfig[] = [
            {
                title: EditIncomeDrawdownSteppersMap.DrawdownDetails,
                url: Urls.get().EditIncomeDrawdownDetails,
                path: Contents.URLMap.drawdownDetail,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },

                component: <DrawdownDetails {...this.getStepProps(0)} />,
            },
            {
                title: EditIncomeDrawdownSteppersMap.IncomePaymentDetails,
                url: Urls.get().EditIncomeDrawdownIncomePaymentDetails,
                path: Contents.URLMap.incomePayment,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                component: <IncomePaymentDetails {...this.getStepProps(1)} />,
            },

            {
                title: EditIncomeDrawdownSteppersMap.review,
                url: Urls.get().EditIncomeDrawdownReview,
                path: Contents.URLMap.review,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                needPrint: true,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child?.[2]?.isValid(),
                component: <Review {...this.getStepProps(2)} />,
            },

            {
                title: EditIncomeDrawdownSteppersMap.confirm,
                url: Urls.get().EditIncomeDrawdownConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We've successfully received your instruction to edit income payments for ${data?.ClientDetails?.FirstName ? data?.ClientDetails?.FirstName : ""
                            } ${data?.ClientDetails?.LastName ? data?.ClientDetails?.LastName : ""} (${this.state.clientAccount?.HeadClAccountId}).`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];

        this.stepperConfig = steppers;
    }

    setProcessProps() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "Edit income drawdown";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${data?.ClientDetails?.FirstName} ${data?.ClientDetails?.LastName}`,
            splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        };
        processProps.subTitle = productMap[type];
        return processProps;
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        if (!params["id"]) params["id"] = this.state.data?.DrawdownIncomeAmendmentInstruction?.Id || this.state.data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.InstructionId;
        EditIncomeDrawdownAction.saveInstruction(from, this.state.data, this.state?.customer?.CustomerId, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }
    onCancel() {
        this.onExit();
    }
    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        const queryParams = getQueryParameters();
        const hierarchyId = queryParams["subaccounthierarchyid"];

        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        EditIncomeDrawdownAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            () => this.setState({ isSubmitting: false })
        );
    }
}
